// 电站处理等级：挂在「每一个电站」上，回答"这个站要多急处理"。
// 规则（就看最高类别，不叠加数量/时长）：站内有"影响安全"→P0；否则有"影响收益"→P1；否则仅"普通告警"→P2。
// 与「告警分类」(见 ./category.js) 是两个正交维度：等级=处置优先级，分类=业务影响。
import { CATEGORY_ORDER } from './category'

export const LEVEL_META = {
  P0: { code: 'P0', name: 'P0', label: 'P0' },
  P1: { code: 'P1', name: 'P1', label: 'P1' },
  P2: { code: 'P2', name: 'P2', label: 'P2' },
}
export const LEVEL_ORDER = { P0: 0, P1: 1, P2: 2 }
// 告警分类 → 电站等级：影响安全=P0、影响收益=P1、普通告警=P2
const CATEGORY_TO_LEVEL = ['P0', 'P1', 'P2']

export function getLevelInfo(level) {
  return LEVEL_META[level] || LEVEL_META.P2
}
export function getLevelLabel(level) {
  return getLevelInfo(level).label
}
export function getLevelClass(level) {
  return `lvl-${(level || 'P2').toLowerCase()}`
}

// 单条告警分类 → 对应处置等级（影响安全=P0、影响收益=P1、普通告警=P2）
export function categoryToLevel(category) {
  const rank = CATEGORY_ORDER[category] ?? CATEGORY_ORDER.NORMAL
  return CATEGORY_TO_LEVEL[rank] || 'P2'
}

// 从一组告警推导电站处理等级：取最高分类对应的等级
export function deriveStationLevel(alarms) {
  let topRank = CATEGORY_ORDER.NORMAL
  for (const a of alarms || []) {
    const rank = CATEGORY_ORDER[a.category] ?? CATEGORY_ORDER.NORMAL
    if (rank < topRank) topRank = rank
  }
  return CATEGORY_TO_LEVEL[topRank] || 'P2'
}
